/// <reference path="../../../../tools/typings/tsd.d.ts"/>

module DealerwareWebContent {
    "use strict";

    export class QrCodesPrintController {
        public static $inject: string[] = [
            '$http',
            '$mobilityCompanyAuthentication',
            'DealerwareFleetCollection',
            'DealerwareVehicleModel',
            '$dealerwareLoading',
            '$dealerwareNotification'
        ];

        public vehicles: any[];
        public errors: any[];
        public vehicleCount: number;
        public loadedCount: number;
        public loader: any;

        constructor(public $http: any,
                    public $auth: any,
                    public fleetCollection: any,
                    public DealerwareVehicleModel: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any) {
            this.loader = this.$dealerwareLoading.show('Loading');
            this.fleetCollection.index({
                promise: true,
                params: { location_id: this.$auth.location.id }
            }).then((returnValue: any) => {
                    this.errors = [];
                    this.vehicleCount = returnValue.data.length;
                    this.loadedCount = 0;
                    returnValue.data.forEach((vehicle: any) => {
                        this.DealerwareVehicleModel.loadQrCode({
                            params: {
                                location_id: this.$auth.location.id,
                                id: vehicle.data.id
                            },
                            successCallback: (rv: any, response: any) => {
                                vehicle.data.qr_code = window.URL.createObjectURL(
                                    new Blob([response.data], { type: "image/svg+xml" })
                                );
                                this.checkLoadedCount();
                            },
                            errorCallback: (response: any) => {
                                this.errors.push(response.data.message);
                                this.checkLoadedCount();
                            }
                        });
                    });

                    this.vehicles = returnValue.data;
                },
                (response: any) => { this.$dealerwareNotification.apiError(response); }
            );
        }

        public checkLoadedCount() {
            this.loadedCount++;
            if (this.loadedCount >= this.vehicleCount) {
                this.loader.close();
                if (this.errors.length) {
                    this.$dealerwareNotification.error(
                        this.errors.length + ' QR codes failed to load with the following errors:<ul><li>' +
                        $.unique(this.errors).join('</li><li>') + '</ul>'
                    );
                }
            }
        }
    }

    getDealerwareWebContentModule().controller('QrCodesPrintController', QrCodesPrintController);
}
